import IntlData from "./intlData"
import RegionalTargets from "@geome/intl/lib/regionalTargets"

export default {
  intlData: IntlData,
  baseUrl: "/api/v1",
  gApiSettings: {
    key: process.env.GOOGLE_API_KEY,
  },
  filters: { groups: {} },
  resources: {
    locations: {
      enabled: true,
    },
  },
  map: {
    settings: {
      clickableIcons: false,
      zoom: 6,
      center: {
        lat: 55,
        lng: -4,
      },
    },
    regionalTargets: RegionalTargets,
  },
  amenities: {
    enabled: [
      "air_and_water",
      "atm_in",
      "atm_out",
      "atm",
      "austrian_highway_sticker",
      "baby_change_facilities",
      "bakery_shop",
      "bank_note_acceptor",
      "bottled_gas",
      "burger",
      "cafe",
      "carwash",
      "children_play_area",
      "childs_toilet",
      "clubsmart_card",
      "coca_cola_freestyle",
      "conveyor_and_jet",
      "conveyor",
      "costa_express",
      "credit_card_american_express",
      "credit_card_diners_club",
      "credit_card_general",
      "credit_card_mastercard",
      "credit_card_visa",
      "credit_card",
      "czech_highway_sticker",
      "deli2go",
      "disability_assistance",
      "disabled_facilities",
      "euroshell_card",
      "fleet_card_dkv",
      "fleet_card_eni",
      "fleet_card_esso",
      "fleet_card_general",
      "fleet_card_uta",
      "food_offerings",
      "fuel_card",
      "full_service",
      "guarded_car_park",
      "hgv_lane",
      "high_speed_diesel_pump",
      "hot_food",
      "hungarian_highway_sticker",
      "ido_ticket",
      "jet",
      "lottery",
      "loyalty_cards",
      "loyalty_program",
      "manual",
      "maut_terminal",
      "mobile_airtime",
      "mobile_loyalty",
      "mobile_payment",
      "money_transfer_services",
      "motorway_service",
      "navigator_fleet_loyalty_discount",
      "oil_and_lubricants",
      "others",
      "parking_lanes",
      "partner_card",
      "partner_loyalty_accepted",
      "pay_at_pump",
      "pizza",
      "prayer_room",
      "quick_lubes",
      "restaurant",
      "rollover_and_jet",
      "rollover",
      "sandwich",
      "sconti_bancoposta",
      "selectshop",
      "self_service",
      "service_bay",
      "shell_card",
      "shell_club_smart_extra_card",
      "shop",
      "shower",
      "slovak_highway_sticker",
      "snack_food",
      "standard_toilet",
      "starbucks",
      "supermarket_fuel_discount",
      "telepass_premium",
      "tim_hortons",
      "toilet",
      "truck_parking",
      "truckport",
      "twenty_four_hour",
      "twotheloo",
      "tyre_service",
      "unmanned",
      "utility_payment_services",
      "vacuum",
      "vehicle_identity_system",
      "waitrose",
      "amazon_locker",
      "wifi",
      "pizza_hut_express",
      "budgens",
      "deli_cafe",
      "deli_by_shell",
      "car_wash_mpay",
      "pay_tm",
      "adblue_truck",
      "adblue_car",
      "adblue_pack",
      "migrolino",
      "spar_express",
    ],
    priority: [
      "costa_express",
      "tim_hortons",
      "amazon_locker",
      "budgens",
      "waitrose",
      "starbucks",
      "twotheloo",
      "carwash",
      "deli2go",
    ],
    localised: {
      en_GB: {
        enabled: [
          "carwash",
          "waitrose",
          "costa_express",
          "disability_assistance",
          "budgens",
          "tim_hortons",
          "twotheloo",
          "deli2go",
        ],
        priority: [
          "carwash",
          "waitrose",
          "amazon_locker",
          "costa_express",
          "disability_assistance",
          "budgens",
          "tim_hortons",
          "twotheloo",
          "deli2go",
        ],
      },
      nl_NL: {
        enabled: [
          "carwash",
          "starbucks",
          "disability_assistance",
          "twotheloo",
          "deli2go",
          "budgens",
          "tim_hortons",
          "waitrose",
          "costa_express",
        ],
        priority: [
          "carwash",
          "starbucks",
          "disability_assistance",
          "twotheloo",
          "deli2go",
          "budgens",
          "tim_hortons",
          "waitrose",
          "costa_express",
        ],
      },
    },
  },
}
